import React, { useState, useEffect } from "react";
import { mockApi } from "../../services/mockApi";
import ModalConfirmLogout from "../../components/ModalConfirmLogout";
import ProgressBar from "./components/ProgressBar";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Header from "../../components/Header";

interface TableItem {
  time?: string;
  percent: number;
  typeGame?: string;
  name: string;
  _id: string;
  showIcon?: string;
  vassalage?: string;
}

// Add cyberpunk animations
const cyberpunkStyles = `
  @keyframes scan {
    0% { left: -100%; }
    100% { left: 100%; }
  }
  @keyframes pulse {
    0%, 100% { opacity: 0.5; }
    50% { opacity: 1; }
  }
`;

// Inject styles
if (typeof document !== 'undefined') {
  const styleSheet = document.createElement("style");
  styleSheet.type = "text/css";
  styleSheet.innerText = cyberpunkStyles;
  document.head.appendChild(styleSheet);
}

const imageCasino = [
  {
    url: "assets/NH/menuGame/PG.png",
    link: "/PG",
    name: "PG ĐIỆN TỬ",
  },
  {
    url: "assets/FC.png",
    link: "/FC",
    name: "FC ĐIỆN TỬ",
  },
  {
    url: "assets/NH/menuGame/BNG.png",
    link: "/BNG",
    name: "BNG ĐIỆN TỬ",
  },
  {
    url: "assets/NH/menuGame/CQ9.png",
    link: "/CQ9",
    name: "CQ9 ĐIỆN TỬ",
  },
  {
    url: "assets/NH/menuGame/EVOPLAY.png",
    link: "/EVOPLAY",
    name: "EVOPLAY ĐIỆN TỬ",
  },
  {
    url: "assets/NH/menuGame/FASHPIN.png",
    link: "/FASHPIN",
    name: "FASHPIN ĐIỆN TỬ",
  },
  {
    url: "assets/NH/menuGame/JDB.png",
    link: "/JDB",
    name: "JDB ĐIỆN TỬ",
  },
  {
    url: "assets/NH/menuGame/JILI.png",
    link: "/JILI",
    name: "JILI ĐIỆN TỬ",
  },
  {
    url: "assets/NH/menuGame/PP.png",
    link: "/PP",
    name: "PP ĐIỆN TỬ",
  },
  {
    url: "assets/NH/menuGame/SPADEGAMING.png",
    link: "/SPADEGAMING",
    name: "SPADEGAMING ĐIỆN TỬ",
  },
  {
    url: "assets/NH/menuGame/SPRIBE.png",
    link: "/SPRIBE",
    name: "SPRIBE ĐIỆN TỬ",
  },
  {
    url: "assets/NH/menuGame/VA.png",
    link: "/VA",
    name: "VA ĐIỆN TỬ",
  },
];


const HomeNH = () => {
  const [isShowLogout, setIsShowLogout] = useState(false);
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const [selectedHall, setSelectedHall] = useState<string | null>(null);
  const [tableList, setTableList] = useState<TableItem[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [userInfo, setUserInfo] = useState<any>(null);
  const navigate = useNavigate();

  // Add rainbow animation CSS
  React.useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      @keyframes rainbow {
        0% { color: #ff0000; } /* Red */
        16% { color: #ff8000; } /* Orange */
        33% { color: #ffff00; } /* Yellow */
        50% { color: #00ff00; } /* Green */
        66% { color: #0080ff; } /* Blue */
        83% { color: #8000ff; } /* Purple */
        100% { color: #ff0080; } /* Pink */
      }
    `;
    document.head.appendChild(style);
    return () => {
      if (document.head.contains(style)) {
        document.head.removeChild(style);
      }
    };
  }, []);

  const handleClick = (e: string) => {
    // Lưu thông tin sảnh vào localStorage
    const hallInfo = imageCasino.find(casino => casino.link === e);
    if (hallInfo) {
      localStorage.setItem('selected_hall_info', JSON.stringify({
        name: hallInfo.name,
        avatar: hallInfo.url.startsWith('/') ? hallInfo.url : `/${hallInfo.url}`
      }));
      console.log('Saved hall info:', hallInfo);
    }
    navigate(`/NH/slot${e}`);
  };

  useEffect(() => {
    // set initial
    const check = () => setIsMobile(window.innerWidth <= 430);
    check();
    window.addEventListener("resize", check);
    // load user info for profile area
    try {
      const u = localStorage.getItem("user_info");
      if (u) setUserInfo(JSON.parse(u));
    } catch (err) {
      setUserInfo(null);
    }
    return () => window.removeEventListener("resize", check);
  }, []);

  // Loading frame for mobile only
  useEffect(() => {
    if (isMobile) {
      Swal.fire({
        html: `
          <div style="
            background: 
              radial-gradient(circle at 20% 20%, rgba(138, 43, 226, 0.2) 0%, transparent 60%),
              radial-gradient(circle at 80% 80%, rgba(0, 191, 255, 0.15) 0%, transparent 60%),
              radial-gradient(circle at 50% 50%, rgba(255, 0, 150, 0.1) 0%, transparent 70%),
              linear-gradient(135deg, 
                rgba(10, 10, 25, 0.98) 0%, 
                rgba(20, 20, 40, 0.95) 25%,
                rgba(15, 15, 35, 0.98) 50%,
                rgba(25, 25, 45, 0.95) 75%,
                rgba(10, 10, 25, 0.98) 100%);
            border: 2px solid transparent;
            border-image: linear-gradient(45deg, #8a2be2, #00bfff, #ff0096, #8a2be2) 1;
            border-radius: 20px;
            padding: 40px;
            text-align: center;
            color: white;
            max-width: 350px;
            width: 90%;
            box-shadow: 
              0 0 50px rgba(138, 43, 226, 0.6),
              0 0 100px rgba(0, 191, 255, 0.3),
              0 0 150px rgba(255, 0, 150, 0.2),
              0 20px 60px rgba(0, 0, 0, 0.7),
              inset 0 0 40px rgba(138, 43, 226, 0.15),
              inset 0 0 80px rgba(0, 191, 255, 0.1);
            position: relative;
            font-family: 'Courier New', monospace;
          ">
            <div style="
              display: flex;
              flex-direction: column;
              align-items: center;
              margin-bottom: 30px;
              animation: textGlow 2s ease-in-out infinite;
            ">
              <div style="
                width: 80px;
                height: 80px;
                background: linear-gradient(135deg, #8a2be2, #00bfff);
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-bottom: 20px;
                font-size: 40px;
                color: #000;
                font-weight: bold;
                box-shadow: 
                  0 0 20px rgba(138, 43, 226, 0.6),
                  0 0 40px rgba(0, 191, 255, 0.3);
                animation: iconPulse 1.5s ease-in-out infinite;
                border: 2px solid rgba(255, 255, 255, 0.3);
              ">⚡</div>
              <h2 style="
                margin: 0; 
                color: #8a2be2; 
                font-size: 20px; 
                font-weight: 900;
                text-shadow: 
                  0 0 15px rgba(138, 43, 226, 0.8),
                  0 0 25px rgba(138, 43, 226, 0.5);
                letter-spacing: 2px;
                text-transform: uppercase;
                text-align: center;
                line-height: 1.2;
              ">INITIALIZING HACK TOOL...</h2>
            </div>
            
            <div style="
              margin-bottom: 25px; 
              font-size: 14px;
              display: flex;
              flex-direction: column;
              gap: 8px;
            ">
              <div style="
                padding: 8px 16px;
                background: rgba(255, 255, 255, 0.05);
                border-radius: 6px;
                border: 1px solid rgba(255, 255, 255, 0.1);
                animation: progressGlow 1.5s ease-in-out infinite;
                text-align: center;
              ">
                <span style="color: rgba(255, 255, 255, 0.9); font-weight: 500;">Đang tải dữ liệu sảnh game...</span>
              </div>
              <div data-progress="2" style="
                padding: 8px 16px;
                background: rgba(255, 255, 255, 0.05);
                border-radius: 6px;
                border: 1px solid rgba(255, 255, 255, 0.1);
                animation: progressGlow 1.5s ease-in-out infinite 0.5s;
                text-align: center;
              ">
                <span style="color: rgba(255, 255, 255, 0.9); font-weight: 500;">Đang tải danh sách game...</span>
              </div>
            </div>
            
            <div style="
              width: 100%;
              height: 16px;
              background: rgba(255, 255, 255, 0.1);
              border-radius: 8px;
              overflow: hidden;
              margin-bottom: 15px;
              position: relative;
            ">
              <div id="progress-fill" style="
                width: 0%;
                height: 100%;
                background: linear-gradient(90deg, #8a2be2, #00bfff, #ff0096, #8a2be2);
                border-radius: 8px;
                transition: width 0.3s ease;
                box-shadow: 0 0 10px rgba(138, 43, 226, 0.5);
              "></div>
              <div id="progress-text" style="
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                color: white;
                font-size: 12px;
                font-weight: bold;
                text-shadow: 0 0 5px rgba(0, 0, 0, 0.8);
              ">0%</div>
            </div>
            
            <div style="
              font-size: 14px; 
              color: #00bfff;
              text-shadow: 0 0 10px rgba(0, 191, 255, 0.5);
              letter-spacing: 1px;
            ">
              » HACK TOOL READY «
            </div>
          </div>
          
          <style>
            .loading-frame-popup {
              z-index: 99999 !important;
            }
            @keyframes textGlow {
              0%, 100% { text-shadow: 0 0 10px rgba(138, 43, 226, 0.5); }
              50% { text-shadow: 0 0 20px rgba(138, 43, 226, 0.8); }
            }
            @keyframes iconPulse {
              0%, 100% { transform: scale(1); }
              50% { transform: scale(1.1); }
            }
            @keyframes progressGlow {
              0%, 100% { 
                background: rgba(255, 255, 255, 0.05);
                border-color: rgba(255, 255, 255, 0.1);
              }
              50% { 
                background: rgba(138, 43, 226, 0.1);
                border-color: rgba(138, 43, 226, 0.3);
              }
            }
            @keyframes progressBar {
              0% { transform: translateX(-100%); }
              100% { transform: translateX(100%); }
            }
          </style>
        `,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        background: 'rgba(0, 0, 0, 0.7)',
        customClass: {
          popup: 'loading-frame-popup'
        },
        backdrop: `
          rgba(0, 0, 0, 0.7)
          url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%238a2be2' fill-opacity='0.15'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")
          center/15px
        `
      });

      // Progress bar animation
      let progress = 0;
      const progressInterval = setInterval(() => {
        progress += 3.34; // 100% in ~3 seconds (update every 100ms)
        if (progress > 100) progress = 100;
        
        const progressFill = document.getElementById('progress-fill');
        const progressText = document.getElementById('progress-text');
        
        if (progressFill && progressText) {
          progressFill.style.width = progress + '%';
          progressText.textContent = Math.round(progress) + '%';
        }
        
        // Show "Tải dữ liệu thành công!" when progress reaches 100%
        if (progress >= 100) {
          const lastMessage = document.querySelector('[data-progress="2"]');
          if (lastMessage) {
            lastMessage.innerHTML = '<span style="color: rgba(255, 255, 255, 0.9); font-weight: 500;">Tải dữ liệu thành công!</span>';
          }
          clearInterval(progressInterval);
        }
      }, 100);

      // Close loading after 3 seconds
      setTimeout(() => {
        clearInterval(progressInterval);
        Swal.close();
      }, 3000);
    }
  }, [isMobile]);

  // Normalize string helper (same as Slot.tsx)
  const normalizeString = (str: string) => {
    return str
      .toLowerCase()
  .normalize("NFD")
  .replace(/[\u0300-\u036f]/g, "");
  };

  // Fetch games when selectedHall changes (chỉ dùng cho mobile cũ – giữ code để sau này cần)
  useEffect(() => {
    const fetchTableList = async (hall: string) => {
      try {
        setTableList([]);
        const typeGame = hall.replace(/\//g, "");
        const mockResponse = await mockApi.getTableList(typeGame);
        setTableList(mockResponse.data);
      } catch (err) {
        console.error("Error fetching games for hall", err);
        setTableList([]);
      }
    };

    if (selectedHall) {
      fetchTableList(selectedHall);
    } else {
      setTableList([]);
    }
  }, [selectedHall]);

  // Filtered list using searchTerm
  const filteredTableList = tableList.filter((item) => {
    if (!searchTerm) return true;
    const normalizedTitle = normalizeString(item.name || "");
    const normalizedSearch = normalizeString(searchTerm);
    return normalizedTitle.includes(normalizedSearch);
  });

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  return (
    <div className="container-fluid lobby-bg position-relative mx-auto mb-5 max-w-screen-xl" style={{ position: 'relative' }}>
      {/* Video background */}
      <video 
        autoPlay 
        loop 
        muted 
        playsInline
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: -1,
          backgroundSize: "contain",
          backgroundRepeat: "repeat",
          backgroundPosition: "top"
        }}
      >
        <source
          src={!isMobile ? "/assets/bg-pc.mov" : "/assets/bg-mb.mov"}
          type="video/mp4"
        />
      </video>
      <Header setIsShowLogout={() => setIsShowLogout(true)} />

      {/* Tiêu đề sảnh HomeNH */}
      <div
        style={{
          textAlign: "center",
          marginTop: 36,
          marginBottom: 24,
          color: "#ffffff",
          fontFamily: '"Source Code Pro", monospace',
        }}
      >
        <div
          style={{
            fontWeight: 900,
            fontSize: isMobile ? 32 : 56,
            lineHeight: 1,
            textShadow: "0 0 26px #ff0000",
          }}
        >
          SẢNH SLOTGAME
        </div>
        <div
          style={{
            marginTop: 8,
            fontWeight: 700,
            fontSize: isMobile ? 16 : 20,
            letterSpacing: 2,
            textShadow: "0 0 20px #ff0000",
          }}
        >
          [ CÔNG NGHỆ AI ]
        </div>
      </div>
      
      {/* Grid sảnh – PC và mobile đơn giản */}
      <div className="w-full mb-6 mt-6">
        <div
          id="homeNH-halls-grid"
          className={
            isMobile
              ? "grid grid-cols-2 gap-3 px-4 pb-4"
              : "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 pt-3 all-programs py-8 mb-10"
          }
        >
          {imageCasino.map((e) => (
            <div
              key={e.link}
              data-aos="flip-left"
              data-aos-delay="100"
              className={`aos-init aos-animate cursor-pointer transition-transform transform duration-300 ease-in-out ${
                isMobile ? "" : "hover:scale-100 mb-1"
              }`}
              onClick={() => handleClick(e.link)}
            >
              <div
                className={
                  isMobile
                    ? "box-game w-full max-w-[180px] mx-auto group"
                    : "box-game w-[70%] max-w-[220px] mx-auto group"
                }
              >
                <img
                  src={e.url && e.url.startsWith('/') ? e.url : `/${e.url}`}
                  alt={e.name}
                  onError={(ev) => (ev.currentTarget.src = '/assets/nohu.gif')}
                  className="w-full transition duration-300 ease-in-out group-hover:drop-shadow-[0_0_10px_#1e943b]"
                />
                <label className="mt-2 font-semibold text-white text-center block text-xs sm:text-sm transition duration-300 ease-in-out group-hover:drop-shadow-[0_0_6px_#1e943b]">
                  {e.name}
                </label>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Mobile cũ đã đơn giản hóa thành grid trên, không cần layout riêng nữa */}
      <ModalConfirmLogout
        isShowLogout={isShowLogout}
        setIsShowLogout={() => {
          setIsShowLogout(false);
        }}
      />
    </div>
  );
};

export default HomeNH;
